/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, May 6th 2022, 1:52:16 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { OSLoadingButton } from "ui-widgets";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export const StepContinueButton = ({
  continueText = "Continue",
  onClick = null,
  isLoading = false,
  disabled = false,
}) => (
  <OSLoadingButton
    endIcon={<ArrowForwardIcon />}
    variant="contained"
    className="cta-style-A"
    size="large"
    color="primary"
    type="submit"
    onClick={onClick}
    isLoading={isLoading}
    disabled={disabled}
  >
    {continueText}
  </OSLoadingButton>
);
